import { render, staticRenderFns } from "./FailingAttributes.vue?vue&type=template&id=54a5c4d3"
import script from "./FailingAttributes.vue?vue&type=script&lang=js"
export * from "./FailingAttributes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports